import isFunction from "lodash/isFunction";
import { keymap } from "prosemirror-keymap";
import { Plugin } from "prosemirror-state";
import { Extension } from "../../core/extension";
import { ReactPluginView } from "../../react/react-plugin-view";
import { changeParentNode } from "../../commands/commands";
import { CodeBlockView } from "./codeblock";
import { codeCommandSpec } from "./commands";
import { EditorCodePluginView } from "./components/EditorCodePluginView";
import { arrowHandlers } from "./keymap";
import { codeNodes } from "./nodes";
export class CodeBlockExtension extends Extension {
    addNodes(nodes) {
        return nodes.append(codeNodes);
    }
    addPlugins(schema, plugins, { portalContainer }) {
        return plugins.concat([
            keymap(arrowHandlers),
            new Plugin({
                view: ReactPluginView.create({
                    portalContainer,
                    component: EditorCodePluginView,
                }),
            }),
        ]);
    }
    addSlashCommands(commands) {
        return [...commands, codeCommandSpec];
    }
    addNodeViews(schema, nodeViews) {
        return {
            ...nodeViews,
            code_block: (node, view, getPos) => new CodeBlockView(node, view, isFunction(getPos) ? getPos : () => 0),
        };
    }
    addCommands(schema) {
        return {
            applyCodeBlock: changeParentNode(schema.nodes.code_block),
        };
    }
}
